// src/scene/config/CabanaConfig.ts
// Cabana (tent) interior zoom + interior shade — generated by Debug.
// Paste this entire file to replace src/scene/config/CabanaConfig.ts

// ── Cabana zoom ───────────────────────────────────────────────────────────────
// Desktop (used when viewport width > mobileBreakpointWidth).
export const cabanaCamX   = 0.2400;
// This one is an ABSOLUTE world Y (not an islandPosition offset), so it tracks
// islandPosition.y by hand — raised 0.15 with the island to keep the framing.
export const cabanaCamY   = 0.7200;
export const cabanaCamZ   = -3.0700;
export const cabanaPhi    = 6.6800;
export const cabanaPitch  = -0.2600;
export const cabanaFov    = 49.0000;
// Mobile (used when viewport width ≤ mobileBreakpointWidth). The narrower mobile
// FOV/pose framing is dialled in separately so the tent reads well on phones.
export const cabanaCamXMobile   = 0.2100;
export const cabanaCamYMobile   = 0.8300;   // absolute world Y — raised 0.15 with the island
export const cabanaCamZMobile   = -3.0000;
export const cabanaPhiMobile    = 6.6800;
export const cabanaPitchMobile  = -0.2600;
export const cabanaFovMobile    = 60.0000;

// ── Interior shade (world-space volume) ───────────────────────────────────────
// Center is an OFFSET added to islandPosition (same convention as tentOffset).
export const cabanaShadeX       = 0.3600;
export const cabanaShadeY       = 0.3100;
export const cabanaShadeZ       = -1.0800;
export const cabanaShadeRadiusX = 0.4300;
export const cabanaShadeRadiusY = 1.7800;
export const cabanaShadeRadiusZ = 1.3600;
export const cabanaShadeEdge    = 0.0800;
export const cabanaShadeColor   = 0x141414;
export const cabanaShadeStrength = 1.0000;

// ── Fade speeds (damp lambda) ─────────────────────────────────────────────────
export const cabanaShadeRevealSpeed = 2.0000;
export const cabanaShadeCoverSpeed  = 10.0000;

// ── Reveal trigger ────────────────────────────────────────────────────────────
export const cabanaArriveDist = 0.1200;

// ── Reverse dome ──────────────────────────────────────────────────────────────
// Center is an OFFSET added to islandPosition (same convention as tentOffset).
export const cabanaDomeX       = 0.3000;
export const cabanaDomeY       = 0.9000;
export const cabanaDomeZ       = -0.4000;
export const cabanaDomeRadius  = 3.0000;
export const cabanaDomeColor   = 0x05060a;
export const cabanaDomeOpacity = 1.0000;